export const ENV = process.env.NODE_ENV
export const DEV = ENV === 'development'

// export const ENV_PATH = document.domain.includes("sim") ? '/cross' : ''  // 2.1项目 。SIM 环境多一层cross路径
export const ENV_PATH = document.domain.includes("sim") ? '/d-server-ngw/cs_global/cs-workbench-frame' : ''


export const COMMON_PATH = `${ENV_PATH}/fe`
// export const IS_SIM = ['gsapi-sim100-us01-test', 'gsapi-sim122-us01-test'].includes(window.location.hostname.split('.')[0])
export const URL = {
	arkMain: '//cs-cross.didiglobal.com/',
	login: 'https://mis-auth.didiglobal.com/auth/sso/login?version=1.0&app_id=835',
	logout: '//me.didiglobal.com/logout?redirect_uri=https%3A%2F%2Fmis-auth.didiglobal.com%2Fauth%2F%3Fapp_id%3D835%26jumpto%3Dindex%26callback_index%3D0',
	msgList: '#/messageList'
}

export const needJumpTo = (() => {
	if (window.location.host.includes('intra.didiglobal.com')) {
		return false;
	}

	return true;
})()

// 设置浏览器名称
export const SET_EXPLORER_NAME = function () {
    let useAgent = navigator.userAgent.toLowerCase()
    //ie
    if (useAgent.indexOf("msie") >= 0) {
        return "IE";
    }
    //firefox
    else if (useAgent.indexOf("firefox") >= 0) {
        return "Firefox";
    }
    //Chrome
    else if (useAgent.indexOf("chrome") >= 0) {
        return "Chrome";
    }
    //Opera
    else if (useAgent.indexOf("opera") >= 0) {
        return "Opera";
    }
    //Safari
    else if (useAgent.indexOf("safari") >= 0) {
        return "Safari";
    }
    if (useAgent.indexOf("edge") >= 0) {
        return "edge";
    }

    return "";
}

export const SET_WORKBENCH_VERSION =() =>{
    return sessionStorage.getItem('new_cs_permission') === 'true' ? '2.0' : '1.0'
}
